<div>
  <div class="header" [innerHTML]="'MyProfile_GDPR_OptOut_Header' | translate"></div>
  <p [innerHTML]="'MyProfile_GDPR_OptOut_Message' | translate"></p>
  <p [innerHTML]="'MyProfile_GDPR_OptOut1_Message' | translate"></p>
  <div class="btn-group place_holder">
    <label class="custom_radio_btn"
      >{{ 'MyProfile_GDPR_Yes' | translate }}
      <input
        type="radio"
        [value]="true"
        name="out-services-options"
        [(ngModel)]="options.contactWithAdditionalServices"
        (change)="changedOptions()"/><span class="custom_radio_btn_checkmark"></span
    ></label>
    <label class="custom_radio_btn">
      {{ 'MyProfile_GDPR_No' | translate }}
      <input
        type="radio"
        [value]="false"
        name="out-services-options"
        [(ngModel)]="options.contactWithAdditionalServices"
        (change)="changedOptions()"/><span class="custom_radio_btn_checkmark"></span
    ></label>
  </div>
  <p [innerHTML]="'MyProfile_GDPR_OptOut2_Message' | translate"></p>
  <div class="btn-group">
    <label class="custom_radio_btn"
      >{{ 'MyProfile_GDPR_Yes' | translate }}
      <input
        type="radio"
        [value]="true"
        name="out-marketing-options"
        [(ngModel)]="options.contactWithMarketingMaterials"
        (change)="changedOptions()"/><span class="custom_radio_btn_checkmark"></span
    ></label>
    <label class="custom_radio_btn"
      >{{ 'MyProfile_GDPR_No' | translate }}
      <input
        type="radio"
        [value]="false"
        name="out-marketing-options"
        [(ngModel)]="options.contactWithMarketingMaterials"
        (change)="changedOptions()"/><span class="custom_radio_btn_checkmark"></span
    ></label>
  </div>
</div>
